import { parseBlob } from 'music-metadata-browser';

export async function extractArtworkFromAudio(file: File): Promise<Blob | null> {
    const metadata = await parseBlob(file);
    const picture = metadata.common.picture?.[0];
    if (picture) {
        const uint8Array = new Uint8Array(picture.data);
        return new Blob([uint8Array], { type: picture.format });
    }
    return null;
}
